// Performance-only damage (DESIGN.md §5): barrier hits break the front wing
// and floor, costing downforce and shifting the balance rearwards. No visual
// damage and no retirements; a pit stop fixes it.

export class Damage {
  /** 0 = intact, 1 = wing gone. */
  frontWing = 0;
  floor = 0;

  /** Speed lost into a barrier this step, m/s. Returns true if new damage was done. */
  impact(speedLost: number): boolean {
    const before = this.frontWing + this.floor;
    if (speedLost > 6) this.frontWing = Math.min(1, this.frontWing + (speedLost - 6) / 22);
    if (speedLost > 11) this.floor = Math.min(1, this.floor + (speedLost - 11) / 40);
    return this.frontWing + this.floor > before + 0.04;
  }

  get any(): boolean {
    return this.frontWing > 0.02 || this.floor > 0.02;
  }

  /** Front wing damage worth a new nose at the stop. */
  get needsNose(): boolean {
    return this.frontWing > 0.15;
  }

  /** Multipliers for the car: downforce lost and balance moved rearwards. Wing gone ≈ 1.5 s/lap, worst floor ≈ 1 s/lap (1 % downforce ≈ 0.17 s here). */
  get downforce(): number {
    return 1 - 0.09 * this.frontWing - 0.06 * this.floor;
  }

  get balanceShift(): number {
    return -0.06 * this.frontWing;
  }

  get drag(): number {
    return 1 + 0.03 * this.frontWing;
  }

  repair(): void {
    this.frontWing = 0;
    this.floor = 0;
  }
}
